<template>
    <b-modal
        id="uploadBGImage"
        title="Upload Background Image"
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        ref="BannerCroppa"
    >
        <div v-bind:class="{ 'poster-croppa': sliderType == 'poster', 'banner-croppa': sliderType == 'banner' }" class="border mx-auto">
            <croppa
                v-model="values.croppa"
                @new-image-drawn="onNewImage"
                @zoom="onZoom"
                :width="343"
                :height="sliderType == 'poster' ? 343 : 140"
                placeholder="Choose an Image"
                :show-remove-button="true"
                :placeholder-font-size="14"
                remove-button-color="#ff8828">
            </croppa>
        </div>
        <div id="badge-phone-bg-range-container" class="mx-auto mt-2">
            <input type="range" class="custom-range" id="customRangebg" 
                @input="onSliderChange"
                :min="values.sliderMin"
                :max="values.sliderMax"
                step=".001"
                v-model="values.sliderVal"
            >
        </div>
        <div slot="modal-footer">
            <b-button variant="secondary" @click="closeModal" style="margin-right: .25rem;">
                Cancel
            </b-button>
            <b-button variant="primary" @click="generateBase64" style="margin-left: .25rem;">
                Save
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "BannerCroppa",
    props: ["values", "status", "sliderType"],
    computed: {
        ...mapState("dstoreDesigns", ["modal"])
    },
    data() {
        return {
            base64: null
        };
    },
    methods: {
        onNewImage() {
            this.values.sliderVal = this.values.croppa.scaleRatio;
            this.values.sliderMin = this.values.croppa.scaleRatio / 2;
            this.values.sliderMax = this.values.croppa.scaleRatio * 2;
        },

        onSliderChange(evt) {
            var increment = evt.target.value;
            this.values.croppa.scaleRatio = +increment;
        },

        onZoom() {
            this.values.sliderVal = this.values.croppa.scaleRatio;
        },

        closeModal: function() {
            // console.log("Test");
            this.$store.commit("dstoreDesigns/setModal", {
                type: "croppa",
                status: false,
                base64: null,
                origin: this.modal.croppa.origin
            });
        },

        generateBase64: function() {
            this.base64 = null;
            // console.log(this.base64);
            this.base64 = this.values.croppa.generateDataUrl();
            // console.log(this.base64);
        }
    },
    watch: {
        status: function(status) {
            if (status === true) {
                this.$refs.BannerCroppa.show();
                this.values.croppa.remove();
                this.base64 = null;
            } else {
                this.$refs.BannerCroppa.hide();
                this.values.croppa.remove();
                this.base64 = null;
            }
        },
        base64: function(base64) {
            if (base64 !== null) {
                // console.log("Test");
                this.$store.commit("dstoreDesigns/setModal", {
                    type: "croppa",
                    status: false,
                    base64: this.base64,
                    origin: this.modal.croppa.origin
                });
            }
            // console.log(this.modal);
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
